import { render, staticRenderFns } from "./RolesCardPage.vue?vue&type=template&id=488d5539"
import script from "./RolesCardPage.vue?vue&type=script&lang=js"
export * from "./RolesCardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports